import React from "react";

import {DropdownMenuItem} from "@reside/ui";

import {getResidentTestId} from "../../helper";
import {
  AdmissionFromSearch,
  exportAdmissionAuditData,
} from "../../../../services/AdmissionsService";
import {useDownloadManager} from "../../../../hooks/useDownloadManager";

export const ExportAuditDataDropdownItem = ({
  admission,
  ...props
}: {
  admission: AdmissionFromSearch;
}) => {
  const {start} = useDownloadManager();

  return (
    <DropdownMenuItem
      pointer
      onClick={() => {
        start("Export Audit Data", () => exportAdmissionAuditData(admission.id));
      }}
      testId={getResidentTestId(admission, "exportAuditData")}
      {...props}
    >
      Export Audit Data
    </DropdownMenuItem>
  );
};
